module.exports = __webpack_public_path__ + "static/img/iconofficeactive.8ccf1a1e.svg";